import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var paymentMethodKlarnaIcon = /*#__PURE__*/React.createElement("svg", {
  height: "35",
  width: "56",
  fill: "none",
  viewBox: "0 0 56 35",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v35H0z",
  fill: "#FFB2C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.219 20.435a1.288 1.288 0 0 0-1.186 1.784 1.284 1.284 0 0 0 1.186.8c.707 0 1.281-.58 1.281-1.292a1.284 1.284 0 0 0-1.281-1.292Zm-4.216-.998c0-.977-.828-1.768-1.849-1.768s-1.85.793-1.85 1.768c0 .976.83 1.767 1.851 1.767 1.022 0 1.848-.79 1.848-1.767Zm.008-3.436h2.04v6.872h-2.04v-.44c-.595.41-1.301.63-2.024.63-1.986 0-3.597-1.623-3.597-3.626 0-2.002 1.61-3.625 3.597-3.625a3.55 3.55 0 0 1 2.024.63V16Zm-16.334.895v-.894h-2.09v6.87h2.095v-3.208c0-1.082 1.163-1.663 1.97-1.663h.025v-1.999c-.83 0-1.59.358-2 .894Zm-5.206 2.541c0-.977-.828-1.768-1.849-1.768s-1.85.793-1.85 1.768c0 .976.83 1.767 1.851 1.767 1.022 0 1.848-.79 1.848-1.767Zm.008-3.436h2.041v6.872h-2.04v-.44a3.561 3.561 0 0 1-2.024.63c-1.986 0-3.597-1.623-3.597-3.626 0-2.002 1.61-3.625 3.597-3.625a3.55 3.55 0 0 1 2.024.63V16Zm12.285-.184c-.815 0-1.587.255-2.103.958v-.773h-2.033v6.87h2.058v-3.61c0-1.044.694-1.557 1.532-1.557.896 0 1.413.54 1.413 1.543v3.625h2.038v-4.37c0-1.598-1.261-2.686-2.905-2.686Zm-20.879 7.056h2.137V12.94h-2.137v9.933Zm-9.385.002h2.263v-9.938H5.5v9.939Zm7.914-9.938a7.935 7.935 0 0 1-2.314 5.641l3.127 4.297h-2.794l-3.397-4.67.877-.662a5.724 5.724 0 0 0 2.285-4.605h2.216Z",
  fill: "#0A0B09"
}));

export { paymentMethodKlarnaIcon as default };
//# sourceMappingURL=paymentMethodKlarnaIcon.js.map
